<template>
  <div id="FileInput">
    <input :accept="extensions" ref="fileInput" @change="changeInput" type="file">
  </div>
</template>
<script>
export default {
  name: 'ImageInput',
  props: {
    extensions: {
      type: String,
      required: true
    },
    pos: {
      default: null,
      type: Number
    }
  },
  methods: {
    open() {
      this.$refs.fileInput.click();
    },
    changeInput( event ) {
      
      const file = event.target.files[0];
      const fileReader = new FileReader();

      if ( file.type.match('image') ) {

          fileReader.onload = ( e ) => {


              const img = new Image();

              img.onload = () => this.$emit( "fileChange", img, file, this.pos );

              img.src = e.target.result;
          };
          fileReader.readAsDataURL( file );
      } else {

          fileReader.onload = ( e ) => {

            const blob = new Blob( [ e.target.result ], { type: file.type } );
            const url = URL.createObjectURL( blob );
            const video = document.createElement('video');
            var timeupdate = () => {
                if ( snapImage() ) {
                  
                  video.removeEventListener( 'timeupdate', timeupdate );
                  video.pause();
                }
            };

            video.addEventListener('loadeddata', function() {
                
                if ( snapImage() ) {
                  video.removeEventListener('timeupdate', timeupdate);
                }
            });

            const snapImage = () => {
                const canvas = document.createElement('canvas');
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                canvas.getContext('2d').drawImage( video, 0, 0, canvas.width, canvas.height );
                const image = canvas.toDataURL();
                const success = image.length > 100000;
                
                if ( success ) {
                  
                  const img = new Image();

                  img.onload = () => this.$emit( "fileChange", img, file );

                  img.src = image;
                  // document.getElementsByTagName('div')[0].appendChild(img);
                  URL.revokeObjectURL(url);
                }
                return success;
            };

            video.addEventListener( 'timeupdate', timeupdate );
            video.preload = 'metadata';
            video.src = url;
            // Load video in Safari / IE11
            video.muted = true;
            video.playsInline = true;
            video.play();
          };

          fileReader.readAsArrayBuffer(file);
        }

    }
  }
}
</script>
<style lang="css" scoped>
  #FileInput{
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/helpers/InputFile.vue